export function englishDate(date = new Date()) {
  return date.toLocaleDateString("en-ZA", { weekday: "short", day: "numeric", month: "long", year: "numeric" });
}

export function hebrewDate(date = new Date()) {
  try {
    return new Intl.DateTimeFormat("en-u-ca-hebrew", { day: "numeric", month: "long", year: "numeric" }).format(date);
  } catch {
    return "Hebrew date unavailable";
  }
}
